export default "__VITE_ASSET__4c738e5f__"